import * as ActionTypes from "../Actions/ActionTypes";
import { updateObject } from "../Utility";
import * as LocalStorageKeys from "../../HOCs/Constants/LocalStorageKeys";

const initialState = {
  isLoading: false,
  isLoadingTransparent: false,
  serverStatusCode: 200,
  currentActiveLiveTheme: 1,
  currentLanguage: "hr",
  isShowingLanguagePicker: false,
  isShowingSettingsPicker: false,
  isShowingNumericKeyboard: false,
  printerStatuses: "",
  oddFormatID: 0, //decimal
  sortTypeID: 1, //time desc
  tapeBillInfo: [
    { Value: 10, Count: 0 },
    { Value: 20, Count: 0 },
    { Value: 50, Count: 0 },
    { Value: 100, Count: 0 },
    { Value: 200, Count: 0 }
  ],
  machineInfo: {
    Address: "??",
    BrowserVersion: "v0",
    CurrencyCode: "??",
    CurrentPaperLengthMM: 0,
    DefaultPaperLengthMM: 0,
    MachineGUID: "4C451BF1-43D9-4C57-9D0B-574C60362BF4", //id 7, siroki konferencijska
    //MachineGUID: "6BCD348C-48A2-4E58-803C-D8E1A994D5E4", //id 3
    //MachineGUID: "00000000-0000-0000-0000-000000000000",
    MaximumPayoutCents: 0,
    MinPaperLengthMM: 0,
    TerminalLabel: "??",
    WebAppVersion: "v0",
    CurrentBalanceCents: 0,
    ActiveUserSessionID: 0,
    MinimumBalanceCents: 0,
    MaximumBills10: 0,
    MaximumBills20: 0,
    MaximumBills50: 0,
    MaximumBills100: 0,
    MaximumBills200: 0,
    MaxPairs: 0,
    MaxBetAmountCents: 0,
    MinBetAmountCents: 0,
    MaxWinAmountCents: 0
  }
};

const reducer = (state = initialState, action) => {
  let updatedObject = {};

  //console.log("TRIGGERED ACTION ", action);

  switch (action.type) {
    case ActionTypes.APPSTATE_START_LOADING:
      updatedObject = updateObject(state, {
        isLoading: action.isLoading,
        isLoadingTransparent: action.isTransparent
      });

      //rijesi bug sa smrzavanjem!
      if (action.shouldUpdateLocalStorage) {
        //pisi ga u local storage
        console.log("Saving APPSTATE_START_LOADING in local storage...");
        localStorage.setItem(
          LocalStorageKeys.LOCALSTORAGE_APPSTATE,
          JSON.stringify(updatedObject)
        );
      }

      return updatedObject;
    case ActionTypes.APPSTATE_STOP_LOADING:
      updatedObject = updateObject(state, {
        isLoading: action.isLoading
      });

      //rijesi bug sa smrzavanjem!
      if (action.shouldUpdateLocalStorage) {
        //pisi ga u local storage
        console.log("Saving APPSTATE_STOP_LOADING in local storage...");
        localStorage.setItem(
          LocalStorageKeys.LOCALSTORAGE_APPSTATE,
          JSON.stringify(updatedObject)
        );
      }

      return updatedObject;
    case ActionTypes.APPSTATE_SET_LANGUAGE:
      updatedObject = updateObject(state, {
        currentLanguage: action.languageCode
      });

      if (action.shouldUpdateLocalStorage) {
        //pisi ga u local storage
        console.log("Saving APPSTATE_SET_LANGUAGE in local storage...");
        localStorage.setItem(
          LocalStorageKeys.LOCALSTORAGE_APPSTATE,
          JSON.stringify(updatedObject)
        );
      }

      return updatedObject;
    case ActionTypes.APPSTATE_SERVER_CHANGE_STATUS:
      updatedObject = updateObject(state, {
        serverStatusCode: action.serverStatusCode
      });

      if (action.shouldUpdateLocalStorage) {
        //pisi ga u local storage
        console.log("Saving APPSTATE_SERVER_CHANGE_STATUS in local storage...");
        localStorage.setItem(
          LocalStorageKeys.LOCALSTORAGE_APPSTATE,
          JSON.stringify(updatedObject)
        );
      }

      return updatedObject;
    case ActionTypes.APPSTATE_SET_PRINTER_STATUSES:
      updatedObject = updateObject(state, {
        printerStatuses: action.statuses
      });

      console.log("IN APPSTATE_SET_PRINTER_STATUSES", action.statuses);

      if (action.shouldUpdateLocalStorage) {
        //pisi ga u local storage
        console.log(
          "Saving APPSTATE_SET_PRINTER_STATUSES in local storage... ",
          action.statuses
        );
        localStorage.setItem(
          LocalStorageKeys.LOCALSTORAGE_APPSTATE,
          JSON.stringify(updatedObject)
        );
      }

      return updatedObject;
    case ActionTypes.APPSTATE_CHANGE_CURRENT_LIVE_THEME:
      updatedObject = updateObject(state, {
        currentActiveLiveTheme: action.themeID
      });

      if (action.shouldUpdateLocalStorage) {
        //pisi ga u local storage
        console.log(
          "Saving APPSTATE_CHANGE_CURRENT_LIVE_THEME in local storage..."
        );
        localStorage.setItem(
          LocalStorageKeys.LOCALSTORAGE_APPSTATE,
          JSON.stringify(updatedObject)
        );
      }

      return updatedObject;
    case ActionTypes.APPSTATE_SHOWS_SETTINGS_PICKER:
      updatedObject = updateObject(state, {
        isShowingSettingsPicker: action.isShown
      });

      if (action.shouldUpdateLocalStorage) {
        //pisi ga u local storage
        console.log(
          "Saving APPSTATE_SHOWS_SETTINGS_PICKER in local storage..."
        );
        localStorage.setItem(
          LocalStorageKeys.LOCALSTORAGE_APPSTATE,
          JSON.stringify(updatedObject)
        );
      }

      return updatedObject;
    case ActionTypes.APPSTATE_SHOWS_LANGUAGE_PICKER:
      updatedObject = updateObject(state, {
        isShowingLanguagePicker: action.isShown
      });

      if (action.shouldUpdateLocalStorage) {
        //pisi ga u local storage
        console.log(
          "Saving APPSTATE_SHOWS_LANGUAGE_PICKER in local storage..."
        );
        localStorage.setItem(
          LocalStorageKeys.LOCALSTORAGE_APPSTATE,
          JSON.stringify(updatedObject)
        );
      }

      return updatedObject;
    case ActionTypes.APPSTATE_SHOWS_NUMERIC_KEYBOARD:
      updatedObject = updateObject(state, {
        isShowingNumericKeyboard: action.isShown
      });

      if (action.shouldUpdateLocalStorage) {
        //pisi ga u local storage
        console.log(
          "Saving APPSTATE_SHOWS_NUMERIC_KEYBOARD in local storage..."
        );
        localStorage.setItem(
          LocalStorageKeys.LOCALSTORAGE_APPSTATE,
          JSON.stringify(updatedObject)
        );
      }

      return updatedObject;
    case ActionTypes.APPSTATE_SET_ODD_FORMAT:
      updatedObject = updateObject(state, {
        oddFormatID: action.oddFormatID
      });

      if (action.shouldUpdateLocalStorage) {
        //pisi ga u local storage
        console.log("Saving APPSTATE_SET_ODD_FORMAT in local storage...");
        localStorage.setItem(
          LocalStorageKeys.LOCALSTORAGE_APPSTATE,
          JSON.stringify(updatedObject)
        );
      }

      return updatedObject;
    case ActionTypes.APPSTATE_SET_SORT_TYPE:
      updatedObject = updateObject(state, {
        sortTypeID: action.sortID
      });

      if (action.shouldUpdateLocalStorage) {
        //pisi ga u local storage
        console.log("Saving APPSTATE_SET_SORT_TYPE in local storage...");
        localStorage.setItem(
          LocalStorageKeys.LOCALSTORAGE_APPSTATE,
          JSON.stringify(updatedObject)
        );
      }

      return updatedObject;
    case ActionTypes.APPSTATE_SET_TAPE_BILL_INFO:
      updatedObject = updateObject(state, {
        tapeBillInfo: action.billInfo
      });

      return updatedObject;
    case ActionTypes.APPSTATE_SET_MACHINE_INFO:
      updatedObject = updateObject(state, {
        machineInfo: JSON.parse(action.machineInfo)
      });

      return updatedObject;
    case ActionTypes.APPSTATE_SET_NEW_ROLL_LENGTH:
      var newMachineInfo = { ...state.machineInfo };
      newMachineInfo.CurrentPaperLengthMM = action.newLengthMM;

      updatedObject = updateObject(state, {
        machineInfo: newMachineInfo
      });

      return updatedObject;
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/ReduxStore/Reducers/AppStateReducer.js